//import liraries
import { Dimensions } from "react-native";
import { CONSTANTS } from "../../utilities/Dimensions";
import {CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";
import { COLORS } from "../../constant";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "98%",
      height: 550,
      backgroundColor:COLORS.white,
      borderRadius: 15,
      marginLeft: 20,
      marginTop: 20,
    },
    getOtpWidget:{
      position: "absolute",
      zIndex: 99,
      right: isSmallDevice ? 80 : isTabView ? 60 : 10,
      top: isSmallDevice ? 19 : null,
    },
    modifyBtn:{
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      borderRadius: 15,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#b6b6b6",
    },
    imgDataWidget:{
      marginLeft: 20,
      alignItems: "center",
      flexWrap: "wrap",
      marginTop: 20,
    },
    defaultPic:{
      height: 65,
      width: 65,
      borderRadius: 80,
      marginRight: 10,
    },
    profilePic:{
      height: isSmallDevice ? 63 : 80,
      width: isSmallDevice ? 63 : 80,
      borderRadius: 80,
      marginRight: 10,
    },
    uploadImgWidget:{
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    uploadImgLink:{
      width: isSmallDevice ? 80 : 127,
      height: isSmallDevice ? 17 : 27,
      borderRadius: 22,
      backgroundColor: "#bd2d37",
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },
    submitBtnWrapper:{
      width: 123.5,
      height: 36,
      alignSelf: "center",
      marginTop: 20,
    },
    dropDownViewStyle: {
      width: 280,
      height: 45,
      position: "relative",
      zIndex: 9999,
      opacity: 1,
      backgroundColor: "#fff",
    },
    updateContainerViewStyle: {
      width: 114,
      height: 30,
      alignSelf: "center",
      marginTop: 15,
      marginLeft: 10,
    },
    dropdownHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      zIndex: 999,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#c3c3c3",
      borderRadius: 5,
      padding: 10,
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      borderBottomWidth: 0,
    },

    dropdownHeaderHide: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",

      position: "relative",
      zIndex: 999,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#c3c3c3",
      borderRadius: 5,
      padding: 10,
    },
    showDropdown: {
      display: "flex",
      border: "2px solid #dfdfdf",
      width: 280,
      position: "absolute",
      top: 40,
      zIndex: 99,
      backgroundColor: "#fff",
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      boxShadow: "0 11px 11px 0 rgba(0, 0, 0, 0.16)",
      paddingBottom: 10,
    },

    hideDropdown: { display: "none" },
    container: {
      marginTop: 5,
      marginHorizontal: 20,
      marginRight: null,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingHorizontal: 20,
    },
    lableTextStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.FONTSIZES.DESK18,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: isSmallDevice ? 14 : 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      marginRight: 20,
      paddingBottom: 3,
      width: 150,
    },
    desktopUpdateViewStyle: {
      display: "flex",
      alignSelf: "center",
      marginTop: 20,
      marginLeft: 20,
    },
    mobileUpdateViewStyle: {
      display: "none",
    },
    updateButtonStyle: {
      width: 127,
      height: 27,
      borderRadius: 22,
      backgroundColor: "#bd2d37",
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },
    datePickerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      width: 270,
    },
    datePickerWrapper: {
      flexDirection: "column",
      marginLeft: -40,
      paddingTop: 14,
    },
    dateText: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#fff",
      marginRight: 20,
      marginBottom: 12,
    },
    datePicker: {
      backgroundColor: "#fff",
      borderRadius: 6,
      height: 35,
      padding: 5,
    },
    textInputStyle: {
      width: 280,
      maxWidth: 289,
      height: 36.6,
      backgroundColor: "#f8f8f8",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#c3c3c3",
      borderRadius: 5,

      fontFamily: "Inter",
      fontSize: CONSTANTS.FONTSIZES.DESK18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: CONSTANTS.FONTSIZES.DESK18,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#a7a7a7",
      paddingLeft: 20,
    },
    inputViewStyle: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginVertical: 5,
    },
    updateViewStyle: {
      position: "absolute",
      zIndex: 99,
      right: 10,
      top: null,
    },
    quickLinkViewStyle: {
      justifyContent: "flex-end",
      marginTop: 0,
    },
    mobileViewStyle: {
      display: "none",
    },
    webViewStyle: {
      display: "flex",
      marginTop: "10%",
    },
    quickLinksTextStyle: {
      fontFamily: "Inter",
      fontSize: isSmallDevice ? 8 : 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0.39,
      textAlign: "left",
      color: "#30424e",
      paddingBottom: 13,
      paddingTop: 5,
    },
    secondViewStyle: { marginLeft: 20 },
    corporateViewStyle: {
      marginTop: "3%",
      flexDirection: "row",
      paddingRight: 20,
      paddingHorizontal: 40,
    },
    headerContainer: {
      width: isTabView
        ? Dimensions.get("window").width / 1.45
        : isSmallDevice
        ? CONSTANTS.PROFILE_CARD_WIDTH
        : CONSTANTS.PROFILE_CARD_WIDTH,
      height: isSmallDevice ? 31 : 46,
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#db6735",
      flexDirection: "row",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      paddingHorizontal: 20,
    },
    privacyDiscTextStyle: {
      fontFamily: "Inter",
      fontSize: isTabView ? 12 : CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: isSmallDevice ? 9 : isTabView ? 20 : 26,
      letterSpacing: isSmallDevice ? 0.21 : isTabView ? 0.36 : 0.32,
      textAlign: "left",
      color: "#ffffff",
    },
    privacyButtonContainerStyle: {
      width: isSmallDevice ? 65 : 121.8,
      height: isSmallDevice ? 15 : 29.5,
      backgroundColor: "#ffffff",
      borderRadius: 20,
      alignItems: "center",
    },
    privacyTextStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: isSmallDevice ? 14 : 27,
      letterSpacing: 0,
      textAlign: "left",
      color: "#9c1d25",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    loaderBg: {
      backgroundColor: "white",
      width: "50%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,

      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },
  },

  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        width: "95%",
        height: 800,
        paddingLeft: 0,
        paddingTop: 20,
      },
      container: {
        flexDirection: "column",
      },
      corporateViewStyle: {
        flexDirection: "column",
        paddingHorizontal: null,
      },
      lableTextStyle: {
        width: 150,
      },
      secondViewStyle: {
        marginLeft: 0,
      },
      mobileViewStyle: {
        display: "flex",
      },
      webViewStyle: {
        display: "none",
        marginTop: "10%",
      },
      updateViewStyle: {
        position: "absolute",
        zIndex: 99,
        right: 10,
        top: null,
      },
      quickLinkViewStyle: {
        justifyContent: "flex-end",
        marginTop: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: "100%",
        height: 770,
        paddingTop: 20,
      },
      corporateViewStyle: {
        flexDirection: "column",
        paddingHorizontal: null,
      },
      mobileViewStyle: {
        display: "flex",
      },
      webViewStyle: {
        display: "none",
        marginTop: "10%",
      },
      updateViewStyle: {
        position: "absolute",
        zIndex: 99,
        right: 60,
        top: null,
      },
      textInputStyle: {
        height: 29.3,
      },
      secondViewStyle: {
        marginLeft: 0,
      },
      inputViewStyle: {
        flexDirection: "column",
      },
      lableTextStyle: {
        alignSelf: "flex-start",
        marginLeft: 20,
        textAlign: "right",
      },
      quickLinkViewStyle: {
        justifyContent: "flex-end",
        marginTop: 20,
      },
      container: {
        marginHorizontal: null,
        marginRight: 20,
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: "100%",
        height: 870,
        paddingLeft: 0,
        paddingHorizontal: 10,
        marginLeft: 0,
        paddingTop: 20,
      },
      container: {
        marginHorizontal: null,
        marginRight: 20,
        flexDirection: "column",
      },
      corporateViewStyle: {
        flexDirection: "column",
        paddingHorizontal: null,
      },
      mobileViewStyle: {
        display: "flex",
      },
      overlayContentViewStyle: {
        width: "95%",
      },
      overlay: {
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: "20%",
      },
      webViewStyle: {
        display: "none",
        marginTop: "10%",
      },
      updateViewStyle: {
        position: "absolute",
        zIndex: 99,
        right: 10,
        top: 25,
      },
      desktopUpdateViewStyle: {
        display: "none",
        alignSelf: "center",
      },
      mobileUpdateViewStyle: {
        display: "flex",
        alignSelf: "flex-end",
      },
      updateButtonStyle: {
        width: 80,
        height: 20,
      },
      textInputStyle: {
        height: 29.3,
        width: 250,
      },
      secondViewStyle: {
        marginLeft: 0,
      },
      inputViewStyle: {
        flexDirection: "column",
      },
      lableTextStyle: {
        alignSelf: "center",
        marginLeft: -95,
        paddingBottom: 5,
        textAlign: "flex-start",
      },
      quickLinkViewStyle: {
        justifyContent: "flex-end",
        marginTop: 20,
      },
      updateContainerViewStyle: {
        width: 100,
        height: 20,
        alignSelf: "flex-end",
      },
    },
  }
);

//make this component available to the app
export default useStyles;
